<div class="app-main">
  <app-header data-cy="main-header"></app-header>
  <div
    id="app-main__container"
    class="app-main__container"
  >
    <app-aside data-cy="main-aside"></app-aside>
    <div
      class="main-content"
      [class.main-content--with-appcues-banner]="isAppcuesBannerVisible"
      [class.main-content--collapsed]="isAsideCollapsed"
    >
      <router-outlet [class.hidden]="isAcaFrameVisible"></router-outlet>
      <iframe
        class="aca-frame"
        id="acaFrame"
        title="aca page"
        [src]="acaUrl | byPassSecurityTrust: securityContext.RESOURCE_URL : true"
        [class.hidden]="!isAcaFrameVisible"
        data-cy="main-aca-frame"
      ></iframe>
    </div>
  </div>
</div>
